import { useEffect, useCallback, useMemo } from 'react';
import { useAppDispatch, useAppState } from '@/store';
import { partnersListSelector, getPartnersList } from '../feature';
import debounce from 'lodash.debounce';

const usePartnersListSearch = (limit?: number) => {
  const dispatch = useAppDispatch();
  const { isLoading, error, partnersList } = useAppState(partnersListSelector);

  const searchPartners = useCallback(
    debounce((search?: string) => {
      if (isLoading) return;
      dispatch(getPartnersList({ store_title: search, ...(limit ? { limit } : {}) }));
    }, 1000),
    [limit],
  );

  useEffect(() => {
    searchPartners();
  }, [searchPartners]);

  return useMemo(
    () => ({
      partnersList: partnersList?.data,
      isLoading,
      searchPartners,
      error,
    }),
    [partnersList, isLoading, error],
  );
};

export default usePartnersListSearch;
